export const upDistrictsAndTehsils = {
    Agra: ["Agra", "Kiraoli", "Fatehabad", "Bah", "Etmadpur"],
    Aligarh: ["Aligarh", "Atrauli", "Khair", "Iglas", "Gabhana"],
    Allahabad: ["Allahabad", "Handia", "Karchhana", "Soraon", "Phulpur", "Meja", "Koraon"],
    AmbedkarNagar: ["Akbarpur", "Jalalpur", "Tanda", "Bhiti", "Alapur"],
    Amethi: ["Amethi", "Gauriganj", "Musafirkhana", "Tiloi"],
    Amroha: ["Amroha", "Hasanpur", "Dhanaura"],
    Auraiya: ["Auraiya", "Bidhuna", "Achhalda"],
    Azamgarh: ["Azamgarh", "Sagri", "Mehnagar", "Lalganj", "Phulpur", "Nizamabad", "Burhanpur", "Atraulia"],
    Baghpat: ["Baghpat", "Baraut", "Khekra"],
    Bahraich: ["Bahraich", "Nanpara", "Kaiserganj", "Mahsi"],
    Ballia: ["Ballia", "Bansdih", "Rasra", "Belthara Road", "Sikanderpur"],
    Balrampur: ["Balrampur", "Utraula", "Tulsipur", "Gaisari"],
    Banda: ["Banda", "Naraini", "Atarra", "Baberu"],
    Barabanki: ["Barabanki", "Ramnagar", "Fatehpur", "Haidergarh", "Nawabganj"],
    Bareilly: ["Bareilly", "Aonla", "Faridpur", "Mirganj", "Nawabganj", "Baheri"],
    Basti: ["Basti", "Harraiya", "Rudhauli"],
    Bhadohi: ["Gyanpur", "Suriyawan", "Aurai", "Bhadohi"],
    Bijnor: ["Bijnor", "Dhampur", "Nagina", "Najibabad", "Chandpur"],
    Budaun: ["Budaun", "Bilsi", "Sahaswan", "Dataganj", "Bisauli"],
    Bulandshahr: ["Bulandshahr", "Sikandrabad", "Khurja", "Debai", "Anupshahr"],
    Chandauli: ["Chandauli", "Sakaldiha", "Chakiya", "Naugarh"],
    Chitrakoot: ["Karwi", "Mau", "Manikpur"],
    Deoria: ["Deoria", "Salempur", "Rudrapur", "Bhatpar Rani"],
    Etah: ["Etah", "Jalesar", "Aliganj", "Sakit"],
    Etawah: ["Etawah", "Chakarnagar", "Jaswantnagar", "Saifai"],
    Faizabad: ["Faizabad", "Milkipur", "Rudauli", "Bikapur"],
    Farrukhabad: ["Farrukhabad", "Kaimganj", "Amritpur"],
    Fatehpur: ["Fatehpur", "Bindki", "Khaga"],
    Firozabad: ["Firozabad", "Sirsaganj", "Shikohabad", "Jasrana"],
    GautamBuddhaNagar: ["Noida", "Greater Noida", "Dadri", "Jewar"],
    Ghaziabad: ["Ghaziabad", "Modinagar", "Hapur", "Loni"],
    Ghazipur: ["Ghazipur", "Mohammadabad", "Zamania", "Saidpur", "Jakhanian"],
    Gonda: ["Gonda", "Tarabganj", "Colonelganj", "Karnailganj"],
    Gorakhpur: ["Gorakhpur", "Sahjanwa", "Bansgaon", "Chauri Chaura", "Campierganj"],
    Hamirpur: ["Hamirpur", "Rath", "Maudaha", "Sarila"],
    Hardoi: ["Hardoi", "Shahabad", "Sandi", "Bilgram", "Sandila"],
    Hathras: ["Hathras", "Sadabad", "Sikandra Rao"],
    Jalaun: ["Jalaun", "Orai", "Kalpi", "Madhogarh"],
    Jaunpur: ["Jaunpur", "Shahganj", "Badlapur", "Kerakat", "Machhlishahr"],
    Jhansi: ["Jhansi", "Mauranipur", "Moth", "Garautha"],
    Kannauj: ["Kannauj", "Chhibramau", "Tirwa"],
    KanpurDehat: ["Akbarpur", "Rasulabad", "Bilhaur", "Sikandra"],
    KanpurNagar: ["Kanpur", "Ghatampur", "Bilhaur"],
    Kasganj: ["Kasganj", "Patiyali", "Sahawar"],
    Kaushambi: ["Manjhanpur", "Chail", "Saraswan"],
    Kushinagar: ["Padrauna", "Hata", "Tamkuhi Raj", "Kasia"],
    LakhimpurKheri: ["Lakhimpur", "Gola Gokaran Nath", "Mitauli", "Mohammadi"],
    Lalitpur: ["Lalitpur", "Mahroni", "Talbehat"],
    Lucknow: ["Lucknow", "Mohanlalganj", "Malihabad", "Bakshi Ka Talab"],
    Maharajganj: ["Maharajganj", "Nautanwa", "Siswa Bazar", "Farisganj"],
    Mahoba: ["Mahoba", "Charkhari", "Kulpahar"],
    Mainpuri: ["Mainpuri", "Karhal", "Kishni", "Bhogaon"],
    Mathura: ["Mathura", "Mant", "Chhata", "Govardhan"],
    Mau: ["Mau", "Ghosi", "Muhammadabad Gohna"],
    Meerut: ["Meerut", "Mawana", "Sardhana", "Bahsuma"],
    Mirzapur: ["Mirzapur", "Chunar", "Lalganj", "Marihan"],
    Moradabad: ["Moradabad", "Bilari", "Thakurdwara", "Kundarki"],
    Muzaffarnagar: ["Muzaffarnagar", "Shamli", "Budhana", "Jansath"],
    Pilibhit: ["Pilibhit", "Bisalpur", "Bilsanda"],
    Pratapgarh: ["Pratapgarh", "Kunda", "Patti", "Raniganj"],
    RaeBareli: ["Rae Bareli", "Maharajganj", "Lalganj", "Salon"],
    Rampur: ["Rampur", "Shahabad", "Bilaspur", "Milak"],
    Saharanpur: ["Saharanpur", "Deoband", "Nakur", "Behat"],
    Sambhal: ["Sambhal", "Chandausi", "Gunnaur"],
    SantKabirNagar: ["Khalilabad", "Mehdawal", "Dhanghata"],
    Shahjahanpur: ["Shahjahanpur", "Powayan", "Tilhar", "Jalalabad"],
    Shamli: ["Shamli", "Kairana", "Thana Bhawan"],
    Shravasti: ["Bhinga", "Ikauna"],
    SiddharthNagar: ["Naugarh", "Bansi", "Itwa", "Shohratgarh"],
    Sitapur: ["Sitapur", "Biswan", "Mahmudabad", "Laharpur", "Sidhauli"],
    Sonbhadra: ["Robertsganj", "Ghorawal", "Dudhi"],
    Sultanpur: ["Sultanpur", "Lambhua", "Jaisinghpur", "Kurada Badshahpur"],
    Unnao: ["Unnao", "Safipur", "Bangarmau", "Hasanganj"],
    Varanasi: ["Varanasi", "Pindra", "Rohania"]
  };
  
  console.log(upDistrictsAndTehsils);
  